import type { SerializedKitAsset } from '../../../../redux/api/fymAPI.types';
import { inlineMediaUrl } from '../../promote/inlineMediaUrl';
import type { SerializedReel } from '../../promote/types';
import type { AssetViewerItem } from '../../promote/viewer/viewerItems';
import type { WatermarkDownloadFile } from '../choice/WatermarkDownloadLink';
import { thumbShapeOf } from './watermarkedFile';

function pictureUrl(relative: string | null): string | null {
  return relative === null ? null : inlineMediaUrl(relative);
}

/** What the choice (design: trial-upsell a2) shows about the file of the asset viewer. */
export function choiceFileOfViewerItem(
  item: AssetViewerItem,
  label: string | null,
  songTitle: string | null
): WatermarkDownloadFile {
  return {
    label,
    songTitle,
    thumbUrl: pictureUrl(item.posterUrl ?? (item.mediaKind === 'image' ? item.fileUrl : null)),
    shape: thumbShapeOf(item.width, item.height),
    width: item.width,
    height: item.height,
    preview: item.preview,
  };
}

/** What the choice shows about a ready kit asset (a Kit slot, the music video slot). */
export function choiceFileOfKitAsset(
  asset: SerializedKitAsset,
  label: string | null,
  songTitle: string | null
): WatermarkDownloadFile {
  const picture = asset.thumbUrl ?? asset.posterUrl ?? (asset.durationSec === null ? asset.fileUrl : null);
  return {
    label,
    songTitle,
    thumbUrl: pictureUrl(picture),
    shape: thumbShapeOf(asset.width, asset.height),
    width: asset.width,
    height: asset.height,
    preview: asset.preview === true,
  };
}

/** What the choice shows about an AI reel: 9:16, 540 x 960 for a preview. */
export function choiceFileOfReel(
  reel: SerializedReel,
  label: string | null,
  songTitle: string | null
): WatermarkDownloadFile {
  return {
    label,
    songTitle,
    thumbUrl: pictureUrl(reel.video?.posterUrl ?? null),
    shape: 'story',
    width: reel.width ?? null,
    height: reel.height ?? null,
    preview: reel.preview === true,
  };
}
